import {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useContext,
} from "react";
import type { Notification } from "../types";
import { useViewModel } from "./useViewModel";

export type NotificationContextType = {
  notifications: Notification[];
  initialLoading: boolean;
  loading: boolean;
  unreadCount: number;
  hasMore: boolean;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  fetchPaginatedNotifications: () => Promise<void>;
  markAsRead: (id: string) => Promise<void>;
  markAllAsRead: () => Promise<void>;
  deleteAll: () => Promise<void>;
  refetch: () => void;
};

const NotificationContext = createContext<NotificationContextType | null>(null);

export const useNotificationContext = (): NotificationContextType => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useNotificationContext must be used within NotificationProvider",
    );
  }
  return context;
};

type Props = {
  children: ReactNode;
};

export const NotificationProvider = ({ children }: Props) => {
  const value = useViewModel();
  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};
